<div class="aeg-billing-details">
    <vl-form-grid mod-stacked>
        <vl-column :width="(billingDetail.emails?.length ?? 0) > 1 ? '6' : '12'">
            <div class="aeg-billing-details__company">
                <aeg-company-info :identifier="billingDetail.vatNumber" :name="billingDetail.companyName" />
            </div>
            <div class="aeg-billing-details__address">
                <address class="aeg-billing-details__address" v-if="billingAddress">
                    <vl-icon icon="location" /><span :class="{'aeg-billing-details__address-unknow': !hasAddress }">{{billingAddress}}</span>
                </address>
            </div>
            <div class="aeg-billing-details__email" v-if="(billingDetail.emails?.length ?? 0) === 1">
                <vl-icon icon="mail" /><span :class="{'aeg-billing-details__email-unknow': !hasEmail }">{{formatEmail(billingDetail.emails[0].email)}}</span>
            </div>
        </vl-column>
        <vl-column :width="'6'" v-if="(billingDetail.emails?.length ?? 0) > 1">
            <div class="aeg-billing-details__email" v-for="email in billingDetail.emails" :key="email.service">
                <vl-icon icon="mail" /><span>{{email.service}}: </span><span :class="{'aeg-billing-details__email-unknow': !hasEmail(email.email) }">{{formatEmail(email.email)}}</span>
            </div>
        </vl-column>
    </vl-form-grid>
</div>